import { Box } from '@mui/material';
import { PaginationIndicator } from 'ogp/components/common/pagination-indicator';
import { useLevelPagination } from 'ogp/hooks/queryHooks/misc/use-level-pagination';
import { usePageProvider } from 'ogp/layouts';
import { RenderUnsettledUI } from 'shared/components/render-unsettled-ui/render-unsettled-ui';
import { LWModal } from 'redesign/modal/modal';
import { FlexPoolsTable, FlexPoolsTableColumnDefinition } from './table';
import { useFlexPoolDetail } from './hooks/use-flexpool-detail';
import { useGetInternalFlexPools as useGetInternalFlexpools } from '../../hooks/use-get-internal-flex-pools';
import { FlexPoolDetail } from '../../../flex-pool-detail/flex-pool-detail';

export const InternalFlexPools = () => {
  const [{ filters }] = usePageProvider();
  const pagination = useLevelPagination();
  const { id, open, close } = useFlexPoolDetail();
  const handleFlexPoolClick = (row: FlexPoolsTableColumnDefinition) => {
    open(row.id);
  };
  const flexPoolListQuery = useGetInternalFlexpools({
    page: pagination.page,
    size: pagination.size,
    departmentId: filters.departmentId,
  });

  if (flexPoolListQuery.status !== 'success') {
    return <RenderUnsettledUI data={flexPoolListQuery} />;
  }

  return (
    <Box display="flex" width="100%" maxHeight={'100%'} flexDirection={'column'}>
      <FlexPoolsTable data={flexPoolListQuery.data} onRowClick={handleFlexPoolClick} />
      <Box mt="auto">
        <PaginationIndicator
          pageCount={flexPoolListQuery.data.totalCount}
          pagination={pagination}
        />
      </Box>
      <LWModal isOpen={!!id} onClose={close} testId="flex-pool-detail">
        {id ? <FlexPoolDetail id={id} onClose={close} /> : null}
      </LWModal>
    </Box>
  );
};
